import { useQuery } from '@tanstack/react-query';
import { GLOBAL_FILTER_KEY } from '../constants';
import { getGlobalFilterItems } from '../utils';
import { useReadGlobalFilter } from './use-global-filter';

/** The active global filter resolved to displayable items. Shared key, so the
 *  sidebar trigger and the selector ride one request. */
export function useGlobalFilterItems() {
  const globalFilter = useReadGlobalFilter();
  return useQuery({
    queryKey: [GLOBAL_FILTER_KEY, globalFilter],
    queryFn: () => getGlobalFilterItems(globalFilter),
  });
}
